import ReactPDF, { Font, Image, View } from '@react-pdf/renderer';
import React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import { Page, Text, Document, StyleSheet } from '@react-pdf/renderer';
import { AnyObject } from 'final-form';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
import PhoneNumber from 'src/models/PhoneNumber';
import LocationModel from 'src/models/leasing/LocationModel';
// tslint:disable: max-line-length

Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
});

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#FFFFFF',
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 55,
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: '#8e9094',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    bold: {
        fontFamily: 'Times-Bold',
    },
    fontNormal: {
        fontFamily: 'Times-Roman',
        fontSize: 9,
    },
    mt1: {
        marginTop: 10,
    },
    mt2: {
        marginTop: 20,
    },
    mt3: {
        marginTop: 30,
    },
    mt4: {
        marginTop: 40,
    },
    mb2: {
        marginBottom: 20,
    },
    mr1: {
        marginRight: 5,
    },
    mr2: {
        marginRight: 20,
    },
    ml1: {
        marginLeft: 5,
    },
    ml2: {
        marginLeft: 20,
    },
    center: {
        textAlign: 'center',
    },
    text: {
        textAlign: 'justify',
    },
    underlined: {
        textDecoration: 'underline',
    },
    mailingInfo: {
        fontSize: 10,
        fontFamily: 'Times-Roman',
    },
    exhibitHeading: {
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 'bold',
    },
    leaseHeading: {
        textAlign: 'center',
        fontSize: 20,
        fontFamily: 'Times-Bold',
    },
    doubleLines: {
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
    },
    h2: {
        fontSize: 12,
    },
    lessorLabel: {
        width: '75px',
        fontSize: 9,
        textAlign: 'right',
        marginRight: '4',
        fontWeight: 'bold',
    },
    lessorData: {
        maxWidth: '20%',
        fontSize: 9,
    },
    footerText: {
        color: 'grey',
        fontSize: 9,
    },
    ownershipColumn: {
        width: '14%',
        fontSize: 9,
        textAlign: 'right',
    },
    bonusColumn: {
        width: '14%',
        fontSize: 9,
        textAlign: 'right',
        paddingRight: 15,
    },
});

interface ILPRDialogOwnProps {
    hideDialog?: () => void;
    leaseData: AnyObject;
    location?: LocationModel;
}

const LPRDialog = (props: ILPRDialogOwnProps) => {
    const dispatch = useDispatch();
    // const firstIncludedTract = props?.leaseData?.tracts?.find((tract: AnyObject) => tract.includeTract === true);
    const totalGrossAcres = props?.leaseData?.tracts?.reduce((acc: number, tract: AnyObject) => {
        if (tract.includeTract === true) {
            let tempGrossAcres = parseFloat(tract.grossAcres) || 0;
            return acc + tempGrossAcres;
        } else {
            return acc;
        }
    }, 0);
    const totalnetAcres = props?.leaseData?.tracts?.reduce((acc: number, tract: AnyObject) => {
        if (tract.includeTract === true) {
            let tempNetAcres = (parseFloat(tract.grossAcres) || 0) * (parseFloat(tract.decimalInterest) || 0);
            return acc + tempNetAcres;
        } else {
            return acc;
        }
    }, 0);

    const leaseDescription = () => {
        const tractList = props.leaseData?.tracts as AnyObject[];
        const includedTracts = tractList?.length > 0 ? tractList.filter((tract) => (tract.includeTract === true)) : undefined;

        if (includedTracts?.length > 0) {
            return includedTracts.map((tract, index) => {
                return (
                    <View key={index} style={{ flexDirection: 'row' }}>
                        <Text style={[styles.fontNormal]}>Tract {index + 1}</Text>
                        <Text style={[styles.fontNormal, { marginLeft: 3, marginRight: 3 }]}>-</Text>
                        <Text style={[styles.fontNormal]}>{tract.legalDescription}</Text>
                    </View>
                );
            });
        } else {
            return <Text>No Tracts Included On Lease</Text>;
        }
    };

    const calcBonus = (netAcres: number) => {
        let bonus = 0;

        if (props.leaseData?.bonusUnit === 'per-acre') {
            bonus = netAcres * props.leaseData?.bonusAmount || 0;
        } else if (props.leaseData?.bonusUnit === 'flat-fee') {
            bonus = props.leaseData?.bonusAmount || 0;
        }
        return currencyFormatter(bonus);
    };

    const tractOwnership = () => {
        const tractList = props.leaseData?.tracts as AnyObject[];
        const includedTracts = tractList?.length > 0 ? tractList.filter((tract) => (tract.includeTract === true)) : undefined;

        if (includedTracts?.length > 0) {
            return includedTracts.map((tract, index) => {
                return (
                    <View key={index} style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Text style={[styles.ownershipColumn]}>
                            {(tract.section || 'N/A') + '-' + (tract.township || 'N/A') + '-' + (tract.range || 'N/A')}
                        </Text>
                        <Text style={[styles.ownershipColumn]}>{tract.horizonNumber}</Text>
                        <Text style={[styles.ownershipColumn]}>{tract.sectionNumber + '.' + tract.tractNumber + '.' + tract.horizonNumber}</Text>
                        <Text style={[styles.ownershipColumn]}>{tract?.decimalInterest || 0}</Text>
                        {/* <Text style={[styles.ownershipColumn]}>{MathUtil.cleanNumber((tract?.decimalInterest || 0), 9)}</Text> */}

                        <Text style={[styles.ownershipColumn]}>{tract?.grossAcres || 0}</Text>
                        {/* <Text style={[styles.ownershipColumn]}>{MathUtil.cleanNumber((tract?.grossAcres || 0), 7)}</Text> */}

                        <Text style={[styles.ownershipColumn]}>{tract?.grossAcres * tract?.decimalInterest || 0}</Text>
                        {/* <Text style={[styles.ownershipColumn]}>{MathUtil.cleanNumber((tract?.netAcres || 0), 7)}</Text> */}

                        <Text style={[styles.ownershipColumn]}>{calcBonus(tract?.grossAcres * tract?.decimalInterest || 0) || 0}</Text>
                    </View>
                );
            });
        } else {
            return <Text style={{ fontSize: '9' }}>No Tracts Included On Lease</Text>;
        }
    };

    const isClausePresent = (clauseId: number) => {
        const clauseData = props.leaseData?.leaseDoc?.leaseClauses;

        const hasClause = clauseData?.find((clause: AnyObject) => {
            return clause?.leaseClauseTypeId === clauseId;
        });

        return hasClause ? true : false;
    };

    const currencyFormatter = (value: number) => {
        const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

        return formatter.format(value);
    };

    const renderPhoneNumbers = () => {
        let phones: PhoneNumber[] = props?.leaseData?.leasehold?.mineralOwner?.phoneNumberChanges?.phoneNumbers;

        return phones?.map((p) => {
            switch (p?.typeId) {
                case 1:
                    return (
                        <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                            <Text style={[styles.lessorLabel]}>Mobile Phone:</Text>
                            <Text style={[styles.fontNormal, styles.lessorData]}>{p?.number}</Text>
                        </View>
                    );
                case 2:
                    return (
                        <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                            <Text style={[styles.lessorLabel]}>Office Phone:</Text>
                            <Text style={[styles.fontNormal, styles.lessorData]}>{p?.number}</Text>
                        </View>
                    );
                case 3:
                    return (
                        <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                            <Text style={[styles.lessorLabel]}>Fax Phone:</Text>
                            <Text style={[styles.fontNormal, styles.lessorData]}>{p?.number}</Text>
                        </View>
                    );
                case 4:
                    return (
                        <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                            <Text style={[styles.lessorLabel]}>Home Phone:</Text>
                            <Text style={[styles.fontNormal, styles.lessorData]}>{p?.number}</Text>
                        </View>
                    );
                default:
                    return (
                        <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                            <Text style={[styles.lessorLabel]}>Phone:</Text>
                            <Text style={[styles.fontNormal, styles.lessorData]}>NO PHONE NUMBER</Text>
                        </View>
                    );
            }
        });
    };

    return (
        <Dialog title="LPR" dialogName={DialogList.LPR_VIEWER} onCloseDialog={() => dispatch(actions.layout.hideDialog())}>
            <ReactPDF.PDFViewer style={{ height: '85vh', width: '70vw' }}>
                <Document>
                    <Page size="LEGAL" style={styles.page}>
                        <View
                            fixed={true}
                            style={{
                                flexDirection: 'row',
                                marginBottom: '5px',
                                justifyContent: 'space-between',
                                borderBottom: '1',
                                borderBottomStyle: 'solid',
                                borderBottomColor: 'black',
                            }}
                        >
                            <Image src="/images/logo/DudleyLandLogoHighRes.jpg" style={{ objectFit: 'contain', height: 35, width: 70 }} />

                            <View>
                                <Text style={{ fontSize: 11, textDecoration: 'underline', fontFamily: 'Oswald' }}>COMPREHENSIVE PURCHASE REPORT</Text>
                                <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                                    <Text style={{ fontSize: 10 }}>Client: SM Energy | Project: New Mexico Beta-test</Text>
                                </View>
                            </View>

                            <View style={{ display: 'flex', justifyContent: 'space-between' }}>
                                {/* <Text style={{ fontSize: 8 }}>Page | 1 of 1</Text> */}
                                <Text style={{ fontSize: 8 }} render={({ pageNumber, totalPages }) => `Page | ${pageNumber} of ${totalPages}`} />
                                <Text style={{ fontSize: 8 }}>{'Lease Number: ' + (props.leaseData?.leaseNumber || '123456')}</Text>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Lessor:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.ownersOnDocument || 'LESSOR NAME'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Address:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>
                                        {props.leaseData?.ownersAddressOnDocument || 'LESSOR ADDRESS'}
                                    </Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>SSN#/Tax ID:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>
                                        {props.leaseData?.ownersSSNTaxIdOnDocument || 'NO SSN'}
                                    </Text>
                                </View>

                                {renderPhoneNumbers()}
                            </View>

                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                    <Text style={[styles.lessorLabel]}>Lessee:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.lesseeName || 'LESSEE'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Address:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>
                                        {(props.leaseData?.lesseeAddressLine1 || 'NA') +
                                            ', ' +
                                            (props.leaseData?.lesseeCity || 'NA') +
                                            ', ' +
                                            (props.leaseData?.lesseeState || 'NA') +
                                            ', ' +
                                            (props.leaseData?.lesseeZipCode || 'NA') || 'LESSEE ADDRESS'}
                                    </Text>
                                </View>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'row', justifyContent: 'space-around', marginTop: '5' }}>
                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Contract Type:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>
                                        {props.leaseData?.agreementType || 'Oil, Gas Mineral Lease'}
                                    </Text>
                                </View>
                            </View>

                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>County of:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>
                                        {(!!props.location && props?.location?.counties[0]) || 'NO COUNTY'}
                                    </Text>

                                    <Text style={[styles.lessorLabel]}>State of:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>
                                        {props.leaseData?.leaseDoc?.location?.state || 'New Mexico'}
                                    </Text>
                                </View>
                            </View>
                        </View>

                        <Text style={{ textAlign: 'center', fontSize: 10, fontWeight: 'bold', marginBottom: 7, marginTop: 7 }}>
                            LEGAL DESCRIPTION:
                        </Text>
                        {leaseDescription()}

                        <Text style={{ textAlign: 'center', fontSize: 10, fontWeight: 'bold', marginBottom: 7, marginTop: 7 }}>LEASE TERMS:</Text>

                        <View style={{ flexDirection: 'row', justifyContent: 'space-around', marginTop: '5' }}>
                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Lease Date:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDate || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Effective Date:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.effectiveDate || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Expiration Date:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.expirationDate || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Recording Date:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.recordingDate || 'NA'}</Text>
                                </View>
                            </View>

                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Term of Lease:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>
                                        {props.leaseData?.leasehold?.primaryTerm + ' ' + props.leaseData?.leasehold?.primaryTermUnits + '(s)' || 'NA'}
                                    </Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Lease Royalty:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leasehold?.royalty || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Bonus Per Acre:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.bonusAmount || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Recorded:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.volume || 'NA'}</Text>
                                </View>
                            </View>

                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Option To Extend:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>
                                        {(props.leaseData?.leasehold?.renewalOption ? 'Yes' : 'No') || 'NA'}
                                    </Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Extension Term:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>
                                        {props.leaseData?.leasehold?.optionTerm + ' ' + props.leaseData?.leasehold?.optionTermUnits + '(s)' || 'NA'}
                                    </Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Extension Payment:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leasehold?.optionTotalBonus || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Filed by Memorandum:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.filedByMemo || 'NA'}</Text>
                                </View>
                            </View>
                        </View>

                        <Text style={{ textAlign: 'center', fontSize: 10, fontWeight: 'extrabold', marginBottom: 7, marginTop: 7 }}>
                            LIMITED CLAUSE BREAKDOWN:
                        </Text>

                        <View style={{ flexDirection: 'row', justifyContent: 'space-around', marginTop: '5' }}>
                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Depth Pugh:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{isClausePresent(2) ? 'Yes' : 'No' || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>No Deduction:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.noDeduction || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Surface Use Restr:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{isClausePresent(6) ? 'Yes' : 'No' || 'NA'}</Text>
                                </View>
                            </View>

                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Standard Pugh:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{isClausePresent(1) ? 'Yes' : 'No' || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Notice of Assign:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.noticeOfAssign || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>No Surface Use:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.noSurfaceUse || 'NA'}</Text>
                                </View>
                            </View>

                            <View>
                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Depth Exclusion:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{isClausePresent(3) ? 'Yes' : 'No' || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>Consent to Assign:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.consentToAssign || 'NA'}</Text>
                                </View>

                                <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                    <Text style={[styles.lessorLabel]}>See Addl Clauses:</Text>
                                    <Text style={[styles.fontNormal, styles.lessorData]}>{isClausePresent(12) ? 'Yes' : 'No' || 'NA'}</Text>
                                </View>
                            </View>
                        </View>

                        <Text
                            style={{
                                textAlign: 'center',
                                fontSize: 10,
                                fontWeight: 'extrabold',
                                marginBottom: 7,
                                marginTop: 7,
                                borderBottom: '1 solid grey',
                                paddingBottom: 5,
                            }}
                        >
                            CONTRACT NOTES:
                        </Text>
                        <Text style={{ fontSize: '9', textAlign: 'justify' }}>{props.leaseData?.clientFacingNotes || 'NA'}</Text>

                        <Text
                            style={{
                                textAlign: 'center',
                                fontSize: 10,
                                fontWeight: 'extrabold',
                                marginBottom: 7,
                                marginTop: 7,
                                borderBottom: '1 solid grey',
                            }}
                        >
                            TRACT AND HORIZON MINERAL OWNERSHIP SUMMARY:
                        </Text>
                        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderBottom: '1 solid grey' }}>
                            <Text style={[styles.ownershipColumn]}>SEC-TWN-RNG / Survey</Text>
                            <Text style={[styles.ownershipColumn]}>Horizon(s)</Text>
                            <Text style={[styles.ownershipColumn]}>Global ID</Text>
                            <Text style={[styles.ownershipColumn]}>Lessor MI</Text>
                            <Text style={[styles.ownershipColumn]}>Gross Acres</Text>
                            <Text style={[styles.ownershipColumn]}>Net Acres</Text>
                            <Text style={[styles.ownershipColumn]}>Bonus</Text>
                        </View>
                        {tractOwnership()}
                        <View
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-around',
                                borderBottom: '1 double grey',
                                borderTop: '1 solid grey',
                            }}
                        >
                            <Text style={{ width: '43%' }} />
                            <Text style={[styles.ownershipColumn]}>Total</Text>
                            <Text style={[styles.ownershipColumn]}>{totalGrossAcres || 0.0}</Text>
                            <Text style={[styles.ownershipColumn]}>{totalnetAcres || 0.0}</Text>
                            <Text style={[styles.ownershipColumn]}>{currencyFormatter(props.leaseData?.totalConsideration || 0)}</Text>
                        </View>

                        <Text
                            style={{
                                textAlign: 'center',
                                fontSize: 10,
                                fontWeight: 'extrabold',
                                marginBottom: 7,
                                marginTop: 7,
                                borderBottom: '1 solid grey',
                            }}
                        >
                            MINERAL TRACT LEGAL DESCRIPTIONS:
                        </Text>
                        {leaseDescription()}

                        <View wrap={false}>
                            <Text
                                style={{
                                    textAlign: 'center',
                                    fontSize: 10,
                                    fontWeight: 'extrabold',
                                    marginBottom: 7,
                                    marginTop: 7,
                                    borderBottom: '1 solid grey',
                                }}
                            >
                                LEASE INVOICE SUMMARY:
                            </Text>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
                                <View>
                                    <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                        <Text style={[styles.lessorLabel]}>Invoice Number:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>
                                            {props.leaseData?.leaseDoc?.invoice?.invoiceNumber || 'NA'}
                                        </Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                        <Text style={[styles.lessorLabel]}>Invoice Date:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>
                                            {props.leaseData?.leaseDoc?.invoice?.invoiceDate || 'NA'}
                                        </Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                        <Text style={[styles.lessorLabel]}>Invoice Due Date:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>
                                            {props.leaseData?.leaseDoc?.invoice?.invoiceDueDate || 'NA'}
                                        </Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>Check Number:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>
                                            {props.leaseData?.leaseDoc?.invoice?.invoiceCheckNumber || 'NA'}
                                        </Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>Check Date:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>
                                            {props.leaseData?.leaseDoc?.invoice?.invoiceCheckDate || 'NA'}
                                        </Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>Collection Number:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>
                                            {props.leaseData?.leaseDoc?.invoice?.invoiceCollectionNumber || 'NA'}
                                        </Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>Draft Number:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>
                                            {props.leaseData?.leaseDoc?.invoice?.invoiceDraftNumber || 'NA'}
                                        </Text>
                                    </View>
                                </View>

                                <View>
                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>Bonus Per Acre:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.bonusPerAcre || 'NA'}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: '2px' }}>
                                        <Text style={[styles.lessorLabel]}>Total Bonus:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.totalBonus || 'NA'}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>Rental Damages:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.rentalDamages || 'NA'}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>Recording Fees:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.recordingFees || 'NA'}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>Other Fees:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.otherFees || 'NA'}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>Bank Charges:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.bankCharges || 'NA'}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2 }}>
                                        <Text style={[styles.lessorLabel]}>FWD Bank Charges:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>
                                            {props.leaseData?.leaseDoc?.fwdBankCharges || 'NA'}
                                        </Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginBottom: 2, borderTop: '1 double grey' }}>
                                        <Text style={[styles.lessorLabel]}>Total Due:</Text>
                                        <Text style={[styles.fontNormal, styles.lessorData]}>{props.leaseData?.leaseDoc?.totalDue || 'NA'}</Text>
                                    </View>
                                </View>
                            </View>

                            {/* <Text style={{ fontSize: 9, fontWeight: 'extrabold', marginBottom: 7, marginTop: 7 }}>PAYMENT INSTRUCTIONS:</Text> */}
                            <Text style={[styles.fontNormal, { textAlign: 'left' }]}>
                                PAYMENT INSTRUCTIONS: {props.leaseData?.leaseDoc?.paymentInstructions || 'NA'}
                            </Text>
                        </View>

                        <View fixed={true} style={{ position: 'absolute', bottom: '15', left: '0', right: '0', borderTop: '1 solid grey' }}>
                            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                                <Text style={{ fontSize: 12, fontWeight: 'bold', color: 'grey', fontFamily: 'Oswald' }}>Dudley Land Company</Text>
                            </View>
                            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
                                <Text style={[styles.footerText]}>Oklahoma City, Oklahoma | (405) 848-4649</Text>
                                <Text style={[styles.footerText]}>Houston, Texas | (713) 952-7944</Text>
                                <Text style={[styles.footerText]}>Midland, Texas | (432) 695-6999</Text>
                            </View>

                            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
                                <Text style={[styles.footerText]}>Canonsburg, Pennsylvania | (724) 745-4717</Text>
                                <Text style={[styles.footerText]}>Denver, Colorado | (303) 813-0901</Text>
                            </View>
                        </View>
                    </Page>
                </Document>
            </ReactPDF.PDFViewer>
        </Dialog>
    );
};

export default LPRDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/LPRDialog.tsx